<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title>
        @if(edit){
        <p class="font-bold">Editar Ordem de Serviço</p>
        }@else{
        <p class="font-bold">Nova Ordem de Serviço</p>
        }
      </mat-card-title>
    </div>
    <button mat-flat-button class="flex flex-row btn-tg w-12/12" (click)="close()">
      Voltar
    </button>


  </mat-card-header>
  <div class="my-4"></div>




  <mat-vertical-stepper>
    <mat-step>
      <ng-template matStepLabel>Informações Ordem de Serviço</ng-template>
      <!-- @if(edit){ -->
      <service-order-edit [itemOs]="data.item" (valid)="serviceValid($event)"></service-order-edit>
      <!-- <service-order-edit [itemOs]="data.item" (response)="onResponse($event, stepper)"></service-order-edit> -->
      <!-- }@else{
      <service-order-create></service-order-create>
      } -->
      <div class="flex justify-between mt-4">
        <button class="btn-tg" mat-raised-button color="primary" matStepperNext>Próximo</button>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Itinerário</ng-template>
      <itinerary-service-order [itemOs]="data.item" (valid)="handleValid($event)" />
      <div class="flex justify-between mt-4">
        <button class="btn-tg-white" mat-button matStepperPrevious>Voltar</button>
        <button class="btn-tg" mat-raised-button color="primary" matStepperNext
          [disabled]="!itineraryValid">Próximo</button>
      </div>
    </mat-step>

    <mat-step [completed]="passengersValid">
      <ng-template matStepLabel>Passageiros</ng-template>
      <passengers (valid)="passengersValid = $event" [itemOs]="data.item" />
      <div class="flex justify-between mt-4">
        <button class="btn-tg-white" mat-button matStepperPrevious>Voltar</button>
        <button class="btn-tg" mat-raised-button color="primary" (click)="submitForm()"
          [disabled]="!passengersValid || !itineraryValid  || finalized || loading">
          @if(finalized){
          Finalizado
          }@else{
          @if(loading){
          <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
          }@else{
          Concluir
          }
          }
        </button>
      </div>

    </mat-step>
    <!-- <mat-step>
      <ng-template matStepLabel>Agendamento</ng-template>
      <app-schedule />
      <div class="flex justify-between mt-4">
        <button mat-button matStepperPrevious>Voltar</button>
        <button mat-raised-button color="primary" (click)="submitForm()">Concluir</button>
      </div>
    </mat-step> -->
  </mat-vertical-stepper>



</mat-card>
